<template lang="pug">
  .events-show
    .events(v-if='event')
      .event.row
        .col-lg-5
          img(:src='event.attributes.image')
        .col-lg-7
          .event-title(v-text='event.attributes.name')
          loyalty-tiers(:loyaltyTier='event.attributes["loyalty-tier"]')
          .event-description.booking-service-description(v-html='event.attributes.description')
          .event-detail(v-if='showEventDetail(event)')
            .event-detail-title(v-text='$t("bookingService.eventsDetail")')
            .event-detail.booking-service-description(v-html='event.attributes.detail')
          timetrade-button(:text='$t("retailStore.rsvpNow")' v-if='displayTimetrade(event)' :query='timetradeQuery(event)' :activity='event' :loyaltyTiers='event.attributes["beauty-pass-tier"]' :store='store')
          inhouse-button(:text='$t("retailStore.rsvpNow")' v-if='displayInhouse(event)' :activity='event' :loyaltyTiers='event.attributes["beauty-pass-tier"]')
    .events(v-else)
      .events-info
        .main-title(v-text='$t("bookingService.eventsTitle")')
        .main-description(v-text='$t("bookingService.eventsDescription")')
      .event.row(v-for='event in events', :id='event.attributes["slug-url"]')
        .col-lg-5
          img(:src='event.attributes.image')
        .col-lg-7
          router-link(:to="store ? `${store.attributes['slug-url']}/store-events/${event.attributes['slug-url']}` : `store-events/${event.attributes['slug-url']}`")
            .event-title(v-text='event.attributes.name')
          loyalty-tiers(:loyaltyTier='event.attributes["loyalty-tier"]')
          .event-description.booking-service-description(v-html='event.attributes.description')
          .event-detail(v-if='showEventDetail(event)')
            .event-detail-title(v-text='$t("bookingService.eventsDetail")')
            .event-detail.booking-service-description(v-html='event.attributes.detail')
          timetrade-button(:text='$t("retailStore.rsvpNow")' v-if='displayTimetrade(event)' :query='timetradeQuery(event)' :activity='event' :loyaltyTiers='event.attributes["beauty-pass-tier"]' :store='store')
          inhouse-button(:text='$t("retailStore.rsvpNow")' v-if='displayInhouse(event)' :activity='event' :loyaltyTiers='event.attributes["beauty-pass-tier"]')

</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "eventsTitle": "Discover Store Events",
      "eventsDescription": "Discover more excitement in Sephora stores, from exciting new launches to meet and greet sessions with your favourite brand owners.",
      "eventsDetail": "Event Details"
    }
  },
  "lng_zh": {
    "bookingService": {
      "eventsTitle": "Discover Store Events",
      "eventsDescription": "親臨Sephora門店參與各式各樣的活動：從令人興奮的品牌發佈會，到與最愛品牌的創立人會面，應有盡有。",
      "eventsDetail": "Event Details"
    }
  },
  "lng_th": {
    "bookingService": {
      "eventsTitle": "Discover Store Events",
      "eventsDescription": "ตื่นเต้นไปกับอีเวนท์สุดเอ็กซ์คลูซีฟที่คุณจะได้ร่วมสนุกกับกิจกรรมใหม่ ๆ มากมายจากแบรนด์โปรดของคุณ",
      "eventsDetail": "Event Details"
    }
  },
  "lng_id": {
    "bookingService": {
      "eventsTitle": "Discover Store Events",
      "eventsDescription": "Discover more excitement in Sephora stores, from exciting new launches to meet and greet sessions with your favourite brand owners.",
      "eventsDetail": "Event Details"
    }
  },
  "lng_ko": {
    "bookingService": {
      "eventsTitle": "매장 이벤트",
      "eventsDescription": "세포라 매장에서 진행되는 다양한 이벤트를 확인하실 수 있습니다.",
      "eventsDetail": "자세히 보기"
    }
  }
}
</i18n>

<script>
import isEmpty from 'lodash/isEmpty'
import { createNamespacedHelpers } from 'vuex'
import TimetradeButton from './timetrade-button.vue'
import InhouseButton from './inhouse-button.vue'
import LoyaltyTiers from './loyalty-tiers.vue'
const { mapGetters } = createNamespacedHelpers('bookingService')

export default {
  name: 'Events',
  components: { TimetradeButton, LoyaltyTiers, InhouseButton },
  props: [
    'events', 'store', 'event'
  ],
  mounted () {
    if (this.$route.hash) {
      this.$scrollTo(this.$route.hash, 200, {
        offset: -110
      })
    }
  },
  computed: {
    ...mapGetters(['isBookable', 'hasVacancy', 'objectById'])
  },
  methods: {
    timetradeQuery (event) {
      return {
        appointmentTypeId: event.attributes['timetrade-appointment-type-id']
      }
    },
    displayTimetrade (event) {
      if (event.attributes['bookable'] === true) {
        return !isEmpty(event.attributes['timetrade-appointment-type-id'])
      }
      return false
    },
    displayInhouse (event) {
      if (event.attributes['bookable'] === true) {
        return isEmpty(event.attributes['timetrade-appointment-type-id'])
      }
      return false
    },
    showEventDetail (event) {
      return !isEmpty(event.attributes['detail'])
    }
  }
}
</script>

<style scoped lang='scss'>
.events-show {
  line-height: 20px;
}

.event-description,
.event-detail {
  line-height: 18px;
  margin-top: 10px;
  margin-bottom: 15px;
}

.main-title,
.event-title {
  @include font-weight-bold;
  font-size: 16px;
  margin-bottom: 8px;
}

.event-detail-title {
  @include font-weight-bold;
  font-size: 14px;
  text-transform: uppercase;
}

.event {
  padding-top: 20px;
  padding-bottom: 20px;
}

.event+.event {
  border-top: 1px solid $grey-light;
}

img {
  max-width: 100%;
}
</style>
